import { BgGradientMain } from "./bg-gradient.styles";
import React from "react";
import { BgGradientType } from "./bg-gradient.types";

export const BgGradient: React.FC<BgGradientType> = (props): JSX.Element => {
  const { isMobile, imgSrc, sx, h } = props;
  console.log(isMobile, "IntrinsicAttributes");
  return <BgGradientMain isMobile={isMobile} imgSrc={imgSrc} sx={sx} h={h} />;
};
